import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { createEvent } from '../actions/event'

import { createEventStage } from '../actions/event-stage'

import {
  createRiderRequest,
  fulfillRiderRequest,
  deleteRiderRequest
} from '../actions/event-rider-request'

import {
  createRider,
  editRider,
  shareRider,
  removeRiderShare,
  deleteRider
} from '../actions/rider'

import { setModal } from '../actions/modal'

import LoginModal from '../components/modals/login-modal'

import RiderDeleteModal from '../components/modals/rider-delete-modal'
// import RiderSettingsModal from '../components/modals/rider-settings-modal'
import RiderSharingModal from '../components/modals/rider-sharing-modal'
import RiderRemoveShareModal from '../components/modals/rider-remove-share-modal'

import EventCreateModal from '../components/modals/event-create-modal'
import EventStageCreateModal from '../components/modals/event-stage-create-modal'
import EventCreateRiderRequestModal from '../components/modals/event-create-rider-request-modal'
import EventDeleteRiderRequestModal from '../components/modals/event-delete-rider-request-modal'
import EventFulfillRiderRequestModal from '../components/modals/event-fulfill-rider-request-modal'

import RiderCreateModal from '../components/modals/rider-create-modal'
import RiderTableCreateModal from '../components/modals/rider-table-create-modal'
import RiderTableEmbeddingModal from '../components/modals/rider-table-embedding-modal'
// import RiderTableSettingsModal from '../components/modals/rider-table-settings-modal'
import RiderTableSharingModal from '../components/modals/rider-table-sharing-modal'

class Modals extends Component {
  renderModals(modal) {
    const { name, data } = modal
    const { rider } = this.props

    switch(name) {
      case 'LoginModal':
        return (
          <LoginModal
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'EventCreateModal':
        return (
          <EventCreateModal
            createEvent={(event) => this.props.createEvent(event)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'EventStageCreateModal':
        return (
          <EventStageCreateModal
            createEventStage={(stage) => this.props.createEventStage(data.eventId, stage)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'EventCreateRiderRequestModal':
        return (
          <EventCreateRiderRequestModal
            createRiderRequest={(request) => this.props.createRiderRequest(data.eventId, {...request, stage: (data.stage && data.stage.id) || null})}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'EventDeleteRiderRequestModal':
        return (
          <EventDeleteRiderRequestModal
            riderRequest={data.riderRequest}
            deleteRiderRequest={() => this.props.deleteRiderRequest(data.riderRequest.id)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'EventFulfillRiderRequestModal':
        return (
          <EventFulfillRiderRequestModal
            riderRequest={data.riderRequest}
            riders={data.riders}
            fulfillRiderRequest={(rider) => this.props.fulfillRiderRequest(data.riderRequest.id, rider)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'RiderCreateModal':
        return (
          <RiderCreateModal
            createRider={(title) => this.props.createRider(title)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'RiderDeleteModal':
        return (
          <RiderDeleteModal
            title={data.title}
            deleteRider={() => this.props.deleteRider(data.id)}
            setModal={(status) => this.props.setModal(status)} />
        )

      // case 'RiderSettingsModal':
      //   return (
      //     <RiderSettingsModal
      //       rider={data.rider}
      //       editRider={(title, description, artist) => this.props.editRider(title, description, artist)}
      //       deleteRider={() => this.props.deleteRider(data.id)}
      //       setModal={(status) => this.props.setModal(status)} />
      //   )

      case 'RiderSharingModal':
        return (
          <RiderSharingModal
            sharedWithMember={rider.sharedWithMember}
            shareRider={(roles, email) => this.props.shareRider(data.id, roles, email)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'RiderRemoveShareModal':
        return (
          <RiderRemoveShareModal
            member={data.email}
            removeRiderShare={() => this.props.removeRiderShare(data.id, data.email)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'RiderTableCreateModal':
        return (
          <RiderTableCreateModal
            // createRiderTable={(title) => this.props.createRiderTable(data.riderId, title, data.type)}
            setModal={(status) => this.props.setModal(status)} />
        )

      case 'RiderTableEmbeddingModal':
        return (
          <RiderTableEmbeddingModal
            title={data.title}
            url={data.url}
            setModal={(status) => this.props.setModal(status)} />
        )

      // case 'RiderTableSettingsModal':
      //   return (
      //     <RiderTableSettingsModal
      //       title={data.title}
      //       updateRiderTable={(object) => this.props.updateRiderTable(object)}
      //       deleteRiderTable={() => this.props.deleteRiderTable(data.riderId, data.id)}
      //       setModal={(status) => this.props.setModal(status)} />
      //   )

      case 'RiderTableSharingModal':
        return (
          <RiderTableSharingModal
            url={data.url}
            setModal={(status) => this.props.setModal(status)} />
        )

      default:
        return null
    }
  }

  render() {
    if (!this.props.modal.name) return null

    return (
      <div className="modal">
        <div className="modal-escape" onClick={() => this.props.setModal(false)} />

        {this.renderModals(this.props.modal)}
      </div>
    )
  }
}

Modals.propTypes = {
  modal: PropTypes.object,
  setModal: PropTypes.func,
  rider: PropTypes.object,
  createEvent: PropTypes.func,
  createEventStage: PropTypes.func,
  createRiderRequest: PropTypes.func,
  fulfillRiderRequest: PropTypes.func,
  deleteRiderRequest: PropTypes.func,
  createRider: PropTypes.func,
  editRider: PropTypes.func,
  shareRider: PropTypes.func,
  removeRiderShare: PropTypes.func,
  deleteRider: PropTypes.func,
  stageElements: PropTypes.object
}

Modals.defaultProps = {
  modal: {},
  setModal: function() {},
  rider: {},
  createEvent: function() {},
  createEventStage: function() {},
  createRiderRequest: function() {},
  fulfillRiderRequest: function() {},
  deleteRiderRequest: function() {},
  createRider: function() {},
  editRider: function() {},
  shareRider: function() {},
  removeRiderShare: function() {},
  deleteRider: function() {},
  stageElements: {}
}

export const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    rider: state.rider,
    stageElements: state.stageElements
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setModal,
    createEvent,
    createEventStage,
    createRiderRequest,
    fulfillRiderRequest,
    deleteRiderRequest,
    createRider,
    editRider,
    shareRider,
    removeRiderShare,
    deleteRider
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Modals)



// WEBPACK FOOTER //
// ./src/containers/modals.js